<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="microsite-hdr-menuBtn"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="microsite-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>

      <ion-button *ngIf="!offlineMode" (click)="openHelp()" data-cy="microsite-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineMode" (click)="common.openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline-outline"></ion-icon>
      </ion-button>

    </ion-buttons>
    <ion-title data-cy="microsite-hdr-title">My Link</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="padding manual-remove-top-padding has-header">

  <div class="appPage myLink"
    [ngClass]="{'previewContainer' : showPreviewLayout, 'noPreviewContainer': !showPreviewLayout}">

    <div [ngClass]="{'previewLayout' : showPreviewLayout, 'noPreviewLayout': !showPreviewLayout}">

      <div class="profileCard link">
        <div class="profile-image">
          <div class="profile-image__wrapper">
            <div class="profile-image__wrapper--inner">
              <div *ngIf="!userMainImage" button class="addImageDiv color-primary" (click)="openMyProfile('addPhoto')"
                data-cy="microsite-content-prof-addPhotoBtn">
                Add Profile Photo</div>
              <img (click)="openMyProfile()" *ngIf="userMainImage" [src]="userMainImage | safe: 'url'"
                data-cy="microsite-content-prof-photo">
            </div>
          </div>
        </div>
        <div class="userLogoOverlay" *ngIf="userLogoImage">
          <img (click)="openMyProfile()" [src]="userLogoImage | safe: 'url'" data-cy="microsite-content-prof-logo">
        </div>
        <!-- <app-profile-tile [imageUrl]="imageUrl" [logo]="logo"></app-profile-tile> -->

        <div class="editProfileBtn" (click)="openMyProfile()" data-cy="microsite-content-prof-editBtn">Edit Profile
        </div>

        <div class="profileNameInfo">
          <div class="username" (click)="openMyProfile()" data-cy="microsite-content-prof-username">
            {{userData.username}}</div>

          <div class="company" (click)="openMyProfile()" *ngIf="userData.company"
            data-cy="microsite-content-prof-company">
            {{userData.company}}</div>
          <div class="brokerage" *ngIf="!userData.company" class="emptyDivInput" (click)="openMyProfile('addBrokerage')"
            data-cy="microsite-content-prof-addBrokerageBtn">
            {{addBrokerageText}}
          </div>

          <div (click)="openMyProfile()" *ngIf="showSocialLinks" class="profileSocialLinks">
            <div *ngFor="let item of socialLinks">
              <img *ngIf="item.enabled" [src]="item.icon | safe:'url'"
                [attr.data-cy]="'microsite-content-prof-' + item.id ">
            </div>
          </div>
          <div *ngIf="!showSocialLinks" class="emptyDivInput" (click)="openMyProfile()"
            data-cy="microsite-content-prof-addSocialLinksBtn">Add Social Links</div>
        </div>

        <!-- <div id="onlyLinkLogo" *ngIf="userData.webPublished !== true" class="listingTitleSection"><img
            class="myonlylinkLogo" src="/assets/imgs/myonlylinkLogo.png" />
          <div class="subTitle">{{aLinkBuiltForText}}</div>
        </div> -->

      </div>

      <div class="spacer-20"></div>


      <div *ngIf="userData.micrositeUserId === ''" class="full-height">
        <div class="no-microsite-wrapper">
          <img class="image" src="assets/imgs/onlylink-empty-state-icon-lrg.png">
          <div class="label" data-cy="microsite-content-startLeads-title" [innerHTML]="startLeadsTitle">
          </div>
          <ion-button tappable (click)="editMicrositeUsername($event)" color="primary"
            data-cy="microsite-content-startLeads-getStartedBtn">
            Get Started
          </ion-button>
        </div>
      </div>

      <div class="micrositeSecondDiv" *ngIf="userData.micrositeUserId !== ''">

        <label [ngClass]="{'hideUsernameDiv' : showPreviewLayout, 'showUsernameDiv': !showPreviewLayout}"
          class="linkWrapper">

          <div (click)="editMicrositeUsername($event)" *ngIf="userData.micrositeUserId === ''" class="link listWrapper">
            <div class="getStarted">Get Started</div>
            <ol class="listInstructions">
              <li>Create a My Link username</li>
              <li>Add links & listings below</li>
              <li>Publish My Link</li>
              <li>Add My Link to your social media bio to capture more leads</li>
            </ol>
          </div>

          <!--
          <div class="full-width pad-top-10">
            <span (click)="editMicrositeUsername($event)" class="color-primary bold">My Username</span>
            <ion-icon (click)="usernameMoreInfo($event)" class="floatRight" color="primary"
              ios="information-circle-sharp" md="information-circle-sharp"></ion-icon>
          </div>
          -->

          <ion-grid no-padding>
            <ion-row class="fullWidth">
              <ion-col col-6>
                <div class="link bold" *ngIf="userData.micrositeUserId === ''" (click)="editMicrositeUsername($event)">
                  Click to create your
                  username</div>

                <div class="link micrositeLinkURL" *ngIf="userData.micrositeUserId !== ''"
                  (click)="openSlugLink($event)">
                  <div class="inline-block" data-cy="microsite-preview-hdr-url">{{env.onlylink}}</div>
                  <div class="bold inline-block" data-cy="microsite-preview-hdr-micrositeUsername">
                    {{userData.micrositeUserId}}</div>
                </div>
              </ion-col>

              <ion-col class="usernameHelperButtons" col-6>
                <div class="floatRight inline-block">
                  <div *ngIf="usernameLoading === true" class="loadingDots">
                    <ion-spinner name="crescent"></ion-spinner>
                  </div>
                  <!--
                  <div
                    *ngIf="userData.webPublished === true && usernameLoading === false && userData.micrositeUserId !== ''"
                    (click)="openSlugLink($event)" class="slugLink inline-block"> View
                  </div>
                   -->
                  <!-- <ion-button fill="clear"
                    *ngIf="userData.webPublished === true && usernameLoading === false && userData.micrositeUserId !== ''"
                    (click)="copySlug($event)" class="slugLink inline-block" data-cy="microsite-preview-hdr-copyBtn">
                    {{copySlugTitle}}
                  </ion-button> -->

                  <ion-button
                    *ngIf="userData.webPublished === true && usernameLoading === false && userData.micrositeUserId !== ''"
                    fill="clear" (click)="presentMorePopover($event)" data-cy="microsite-preview-hdr-moreBtn"
                    size="small" class="moreButton">
                    <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
                  </ion-button>

                  <!--
                  <ion-icon *ngIf="userData.micrositeUserId === '' && usernameLoading === false"
                    (click)="usernameMoreInfo($event)" class="usernameInfoIcon" color="primary"
                    ios="information-circle-sharp" md="information-circle-sharp"></ion-icon>
                  <ion-icon *ngIf="userData.micrositeUserId !== '' && usernameLoading === false"
                    (click)="openMicrositeUsernameHelper()" class="usernameInfoIcon" color="primary" tappable
                    ios="information-circle-sharp" md="information-circle-sharp">
                  </ion-icon>
                  -->
                </div>
              </ion-col>

            </ion-row>

          </ion-grid>

        </label>

        <!-- <div *ngIf="userData.webPublished" class="myActivityDiv">
          <label class="activityTitle" data-cy="microsite-content-myActivity-title">My Activity</label>
          <div [ngClass]="{'enableFilter' : !analyticsLoading, 'disableFilter': analyticsLoading}"
            class="floatRight link analyticsFilter" (click)="openAnalyticsFilter($event)"
            data-cy="microsite-content-myActivity-analyticsBtn">{{analyticsFilter[1]}} <img
              src="assets/imgs/icn_sort_down.svg"> </div>

          <div *ngIf="analyticsLoading && !analyticsError" class="analyticsSummaryDiv">
            <ion-spinner name="crescent"></ion-spinner>
          </div>

          <div *ngIf="!analyticsLoading && !analyticsError" class="analyticsSummaryDiv">
            <div>
              <div data-cy="microsite-content-myActivity-analytics-views-lbl">{{selectedStats.pageviews}}</div>
              <img src="assets/imgs/icons/eye-outline.svg" data-cy="microsite-content-myActivity-analytics-views-icon">
            </div>
            <div>
              <div data-cy="microsite-content-myActivity-analytics-calls-lbl">
                {{selectedStats.PhoneNumberClick.totalEvents}}</div>
              <img src="assets/imgs/icons/call-outline.svg" data-cy="microsite-content-myActivity-analytics-calls-icon">
            </div>
            <div>
              <div data-cy="microsite-content-myActivity-analytics-sms-lbl">{{selectedStats.SMSClick.totalEvents}}</div>
              <img src="assets/imgs/icons/chatbox-ellipses-outline.svg"
                data-cy="microsite-content-myActivity-analytics-sms-icon">
            </div>
            <div>
              <div data-cy="microsite-content-myActivity-analytics-email-lbl">{{selectedStats.EmailClick.totalEvents}}
              </div>
              <img src="assets/imgs/icons/mail-outline.svg" data-cy="microsite-content-myActivity-analytics-email-icon">
            </div>
          </div>

          <div *ngIf="analyticsError" class="analyticsSummaryDiv">
            <span>We experienced a problem with this request. </span><span (click)="retryAnalytics()"
              class="link bold margin-left-5"> Retry</span>
          </div>

        </div> -->

        <div class="spacer-26"></div>

        <div class="padding segmentSectionOverflow centerAlign">
          <div class="segmentSection">
            <button #linksElement class="segmentButton" [ngClass]="{'enabledSegment' : (segmentValue === 'links')}"
              (click)="segmentChanged('links', linksElement)" data-cy="microsite-content-linksBtn">
              Links
            </button>
            <button #designElement class="segmentButton" [ngClass]="{'enabledSegment' : (segmentValue === 'design')}"
              (click)="segmentChanged('design', designElement)" data-cy="microsite-content-designBtn">
              Design
            </button>
          </div>
        </div>

        <div class="spacer-26"></div>

        <div class="segmentDiv" [ngSwitch]="segmentValue">
          <section *ngSwitchCase="'links'">

            <!-- onlylink takeover -->
            <div class="fullScreenTakeoverWrapper">

              <div class="fullScreenTakeoverHeader">
                <span>Full Screen Takeover </span>
                <span class="link" (click)="showTakeoverInfo($event)">
                  <ion-icon class="slotButtonIcon noTooltip" slot="icon-only" tappable ios="information-circle-sharp"
                    md="information-circle-sharp">
                  </ion-icon>
                </span>
              </div>

              <!-- EMPTY STATE -->
              <div class="fullScreenTakeoverBody link" *ngIf="!userData.onlylinkTakeover?.title"
                (click)="scrollToMyListings()">
                <div class="starOutline fadedIcon listingShareIcons">
                  <span>
                    <ion-icon name="star-outline" class="noTooltip" slot="icon-only"></ion-icon>
                  </span>
                </div>
                <p class="faded">Select a listing to make it a Full Screen Takeover</p>
              </div>

              <!-- FULL STATE -->
              <div class="fullScreenTakeoverBodyFeatured link" *ngIf="userData.onlylinkTakeover?.title"
                (click)="editFullScreenTakeoverDirect($event)">
                <ion-item color="none" button="false" class="linkHeaderFeatured fadeIn" lines="none">

                  <div slot="start" class="starOutline fadedIcon link listingShareIcons"
                    (click)="removeOnlylinkTakeover($event)">
                    <span>
                      <ion-icon name="close-outline" class="noTooltip" slot="icon-only"></ion-icon>
                    </span>
                  </div>

                  <a class="bold wrap-text">
                    <div class="urlTitleWrap">
                      <ion-label class="urlLinkHeader wrap-text">{{ userData.onlylinkTakeover.title }}
                      </ion-label> <img class="urlTitleIcon"
                        [src]="(userData.onlylinkTakeover.landingPage && userData.onlylinkTakeover?.landingPage !== 'listing-microsite') ? '/assets/imgs/open-house-icon.svg' : '/assets/imgs/listing-microsite.svg'">
                    </div>
                    <div class="normal linkLabel wrap-text">
                      {{env.blockparty}}{{userData.onlylinkTakeover.URL}}</div>
                  </a>

                </ion-item>
              </div>

            </div>

            <div class="listingTitleSection" data-cy="microsite-content-featuredLinks-title">My Featured Links
              <span data-cy="microsite-content-featuredLinks-addFeaturedLink" (click)="addFeaturedLink()" class="link"
                *ngIf="featuredLinks.length > 0">
                <ion-icon class="noTooltip" name="add-circle" slot="icon-only">
                </ion-icon>
              </span>
            </div>


            <ion-button *ngIf="featuredLinks.length < 1" outline tappable (click)="addFeaturedLink()" color="primary"
              data-cy="microsite-content-featuredLinks-addFeaturedLink">Add Featured Link
              <ion-icon slot="end" name="add-sharp"></ion-icon>
            </ion-button>

            <ion-reorder-group id="ion-reorder-group1" disabled="false" lines="none"
              (ionItemReorder)="reorderFeaturedLinks($event)" reorder="true">
              <ion-item button="false" class="linkHeader fadeIn" lines="none"
                *ngFor="let item of featuredLinks; index as i">
                <ion-toggle slot="start" color="success" (ionChange)="featuredLinkChanged(item, i, $event.detail)"
                  [(ngModel)]="item.enabled" mode="ios"
                  [attr.data-cy]="'microsite-content-featuredLinks-' + i + '-checkbox'">
                </ion-toggle>

                <a class="bold wrap-text clickEnableCls featuredLinksTitle"
                  (click)="openEditModal('editFeaturedLink', item)">
                  <div class="urlTitleWrap">
                    <ion-label class="urlLinkHeader wrap-text urlTitle"
                      [attr.data-cy]="'microsite-content-featuredLinks-' + i + '-title'"> {{item.title}} </ion-label>
                  </div>

                  <div class="normal linkLabel wrap-text"
                    [attr.data-cy]="'microsite-content-featuredLinks-' + i + '-url'">
                    {{item.URL}}</div>
                </a>

                <ion-reorder slot="end" [attr.data-cy]="'microsite-content-featuredLinks-' + i + '-reorderBtn'">
                </ion-reorder>
              </ion-item>
            </ion-reorder-group>

            <div class="spacer-10"></div>

            <div id="myListings" *ngIf="userData.role ==='agent'" class="listingTitleSection"
              data-cy="microsite-content-listings-title">My
              Listings <span *ngIf="webListings.length > 0 && userData.role ==='agent'" class="link"
                (click)="createNewListing()">
                <ion-icon name="add-circle" class="noTooltip" data-cy="microsite-content-listings-addListingBtn">
                </ion-icon>
              </span>
            </div>

            <div id="myListings" *ngIf="(userData.role === 'lender' || userData.role === 'agentAdmin')"
              class="listingTitleSection">My Paired
              Listings <span *ngIf="webListings.length > 0 && !userData.regionalLender" class="link"
                (click)="createNewListing()">
                <ion-icon class="noTooltip" name="add-circle">
                </ion-icon>
              </span>
            </div>

            <ion-button *ngIf="webListings.length < 1 && userData.role === 'agent'" outline tappable
              (click)="createNewListing()" color="primary" data-cy="microsite-content-listings-addListingBtn">Add
              Listing
              <ion-icon slot="end" name="add-sharp"></ion-icon>
            </ion-button>

            <ion-reorder-group id="ion-reorder-group2" disabled="false" lines="none" reorder="true"
              (ionItemReorder)="reorderWebListings($event)">
              <ion-item button="false" class="linkHeader fadeIn" lines="none"
                *ngFor="let item of webListings; index as i">
                <ion-toggle slot="start" color="success" (ionChange)="webListingsChanged(item, i, $event)"
                  [(ngModel)]="item.enabled" mode="ios"
                  [attr.data-cy]="'microsite-content-listings-' + i + '-checkbox'">
                </ion-toggle>

                <div (click)="handleTakeoverChange(item, i, $event, false)" slot="start"
                  *ngIf="item.fullScreenTakeover === true" class="starFilled link listingShareIcons">
                  <span>
                    <ion-icon class="noTooltip" name="star" slot="icon-only"></ion-icon>
                  </span>
                </div>

                <div (click)="handleTakeoverChange(item, i, $event, true)" slot="start" *ngIf="!item.fullScreenTakeover"
                  class="starOutline fadedIcon link listingShareIcons">
                  <span>
                    <ion-icon class="noTooltip" name="star-outline" slot="icon-only"></ion-icon>
                  </span>

                </div>

                <a class="bold wrap-text clickEnableCls" (click)="openEditModal('mylisting', item, $event)">
                  <div class="urlTitleWrap">
                    <ion-label class="urlLinkHeader wrap-text urlTitle"
                      [attr.data-cy]="'microsite-content-listings-' + i + '-title'"> {{item.title}} </ion-label> <img
                      class="urlTitleIcon"
                      [src]="(item.landingPage && item.landingPage !== 'listing-microsite') ? '/assets/imgs/open-house-icon.svg' : '/assets/imgs/listing-microsite.svg'">

                  </div>

                  <div class="normal linkLabel wrap-text" [attr.data-cy]="'microsite-content-listings-' + i + '-url'">
                    {{env.blockparty}}{{item.URL}}</div>
                </a>

                <ion-reorder slot="end" [attr.data-cy]="'microsite-content-listings-' + i + '-reorderBtn'">
                </ion-reorder>

              </ion-item>
            </ion-reorder-group>

            <ion-reorder-group id="ion-reorder-group3" *ngIf="allListings" disabled="false" lines="none"
              reorder="false">
              <ion-list>

                <ng-container *ngFor="let item of finalResPaginated; index as j">
                  <ion-item *ngIf="item.showListing" button="false" class="linkHeader fadeIn" lines="none">
                    <ng-container *ngIf="item.showListing">

                      <ion-toggle slot="start" mode="ios" [(ngModel)]="item.enabled"
                        (click)="addWeblisting(item, j, $event)">
                      </ion-toggle>

                      <div (click)="handleTakeoverChange(item, j, $event, true)" slot="start"
                        class="starOutline fadedIcon link listingShareIcons">
                        <span>
                          <ion-icon class="noTooltip" name="star-outline" slot="icon-only"></ion-icon>
                        </span>
                      </div>

                      <a class="bold wrap-text clickEnableCls" (click)="takeoverUnavailable()">
                        <div class="urlTitleWrap">
                          <ion-label class="urlLinkHeader wrap-text urlTitle"
                            [attr.data-cy]="'microsite-content-listings-' + i + '-title'"> {{ item.address.title }}
                          </ion-label>
                        </div>
                        <div class="normal linkLabel wrap-text"
                          [attr.data-cy]="'microsite-content-listings-' + i + '-url'">
                          {{env.blockparty}}{{item.slug}}</div>
                      </a>

                    </ng-container>
                  </ion-item>
                </ng-container>
              </ion-list>

              <div class="fullWidth centerAlign">
                <ion-button *ngIf="finalResPaginated.length < totalShowListings.length" color="primary"
                  (click)="generateItems()">See More</ion-button>
              </div>

              <!-- <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
                <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
              </ion-infinite-scroll> -->

            </ion-reorder-group>


          </section>



          <section *ngSwitchCase="'design'">
            <div class="design-option-container">
              <div class="listingTitleSection" data-cy="microsite-content-design-background-title">Background</div>
              <ion-row class="buttons-options-row">
                <ion-col>
                  <div [ngClass]="userData.customEffect === 'solidBackground' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container-longer solid-background" (click)="setCustomEffect('solidBackground')"
                    data-cy="microsite-content-design-background-solid-icon">
                    <ion-icon *ngIf="userData.customEffect === 'solidBackground'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                  </div>
                  <span class="standardLabel outside-label"
                    data-cy="microsite-content-design-background-solid-lbl">Solid</span>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customEffect === 'whiteBackground' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container-longer white-background" (click)="setCustomEffect('whiteBackground')"
                    data-cy="microsite-content-design-background-white-icon">
                    <ion-icon *ngIf="userData.customEffect === 'whiteBackground'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                  </div>
                  <span class="standardLabel outside-label"
                    data-cy="microsite-content-design-background-white-lbl">White</span>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customEffect === 'gradientUp' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container-longer gradient-up" (click)="setCustomEffect('gradientUp')"
                    data-cy="microsite-content-design-background-gradientUp-icon">
                    <ion-icon *ngIf="userData.customEffect === 'gradientUp'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                  </div>
                  <span class="standardLabel outside-label"
                    data-cy="microsite-content-design-background-gradientUp-lbl">Gradient up</span>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customEffect === 'gradientDown' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container-longer gradient-down" (click)="setCustomEffect('gradientDown')"
                    data-cy="microsite-content-design-background-gradientDown-icon">
                    <ion-icon *ngIf="userData.customEffect === 'gradientDown'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                    <div class="example-button"></div>
                  </div>
                  <span class="standardLabel outside-label"
                    data-cy="microsite-content-design-background-gradientDown-lbl">Gradient down</span>
                </ion-col>
              </ion-row>
            </div>

            <div class="design-option-container">
              <div class="listingTitleSection" data-cy="microsite-content-design-buttons-title">Buttons</div>
              <ion-row class="buttons-options-row">
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'squareSolid' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('squareSolid')"
                    data-cy="microsite-content-design-buttons-row1-col1">
                    <ion-icon *ngIf="userData.customButtonShape === 'squareSolid'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button solid"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'roundedSolid' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('roundedSolid')"
                    data-cy="microsite-content-design-buttons-row1-col2">
                    <ion-icon *ngIf="userData.customButtonShape === 'roundedSolid'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button rounded solid"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'roundSolid' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('roundSolid')"
                    data-cy="microsite-content-design-buttons-row1-col3">
                    <ion-icon *ngIf="userData.customButtonShape === 'roundSolid'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button round solid"></div>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="buttons-options-row">
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'square' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('square')"
                    data-cy="microsite-content-design-buttons-row2-col1">
                    <ion-icon *ngIf="userData.customButtonShape === 'square'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'rounded' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('rounded')"
                    data-cy="microsite-content-design-buttons-row2-col2">
                    <ion-icon *ngIf="userData.customButtonShape === 'rounded'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button rounded"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'round' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('round')"
                    data-cy="microsite-content-design-buttons-row2-col3">
                    <ion-icon *ngIf="userData.customButtonShape === 'round'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button round"></div>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row class="buttons-options-row">
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'squareShadow' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('squareShadow')"
                    data-cy="microsite-content-design-buttons-row3-col1">
                    <ion-icon *ngIf="userData.customButtonShape === 'squareShadow'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button shadowed"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'roundedShadow' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('roundedShadow')"
                    data-cy="microsite-content-design-buttons-row3-col2">
                    <ion-icon *ngIf="userData.customButtonShape === 'roundedShadow'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button rounded shadowed"></div>
                  </div>
                </ion-col>
                <ion-col>
                  <div [ngClass]="userData.customButtonShape === 'roundShadow' ? 'selected-bg' : 'unselected-bg'"
                    class="selectable-container" (click)="setButtonsType('roundShadow')"
                    data-cy="microsite-content-design-buttons-row3-col3">
                    <ion-icon *ngIf="userData.customButtonShape === 'roundShadow'" mode="ios" name="checkmark-circle">
                    </ion-icon>
                    <div class="example-button round shadowed"></div>
                  </div>
                </ion-col>
              </ion-row>
            </div>

          </section>

        </div>

        <ng-container *ngIf="segmentValue === 'links'">
          <div class="spacer-25"></div>

          <div (click)="openListingHelper()" class="helpTooltip" data-cy="microsite-content-notSeeingListings-txt">
            <span>{{notSeeingListingsText}} </span>
            <ion-icon color="primary" tappable ios="information-circle-sharp" md="information-circle-sharp">
            </ion-icon>
          </div>
        </ng-container>

        <div class="spacer-25"></div>

        <ion-button class="publish-button" [disabled]="userData.micrositeUserId === ''"
          *ngIf="userData.webPublished !== true" (click)="publishWeb()" outline
          data-cy="microsite-content-publishBtn">Publish</ion-button>
        <ion-button class="publish-button" *ngIf="userData.webPublished === true"
          data-cy="microsite-content-publishedBtn">Published
        </ion-button>

        <div class="spacer-10"></div>

        <div [ngClass]="{'hideUsernameDiv' : showPreviewLayout, 'showUsernameDiv': !showPreviewLayout}"
          class="link pad-5" *ngIf="userData.webPublished === true">
          <div>Not seeing updates?</div>
          <div class="manualSync link" (click)="manualSync();">
            <span class="bold">Manually sync changes</span>
            <img src="assets/imgs/sync.png">
          </div>
        </div>

        <div class="spacer-100"></div>

      </div>
    </div>

    <!-- MICROSITE PREVIEW -->
    <div *ngIf="userData.micrositeUserId !== '' && userData.webPublished" id="micrositePreview">

      <label id="userIdLinkContainer" class="linkWrapper">
        <ion-grid class="no-padding">
          <ion-row no-padding class="fullWidth">
            <ion-col col-7>
              <div class="link" *ngIf="userData.micrositeUserId !== ''" (click)="openSlugLink($event)">
                <div class="inline-block" data-cy="microsite-preview-hdr-url">{{env.onlylink}}</div>
                <div class="bold inline-block" data-cy="microsite-preview-hdr-micrositeUsername">
                  {{userData.micrositeUserId}}</div>
              </div>
            </ion-col>

            <ion-col class="no-padding" col-5>
              <div class="floatRight inline-block">
                <div class="listing-title-hgt pc-lnk">
                  <div class="listingShareIcons" [ngClass]="userData.webPublished ? '' : 'faded'"
                    data-cy="microsite-menu-options">
                    <ion-button *ngIf="number_of_buttons > 0" size="small" fill="clear"
                      class="cpy-lnk-marg inline-block" ion-button (click)="copySlug($event)"
                      data-cy="microsite-preview-hdr-copyBtn">
                      <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="copy-outline"></ion-icon>
                    </ion-button>
                    <ion-button *ngIf="number_of_buttons > 1" size="small" fill="clear" (click)="shareSlugLink($event)">
                      <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="share-social-outline"></ion-icon>
                    </ion-button>
                    <ion-button *ngIf="number_of_buttons > 2" size="small" fill="clear" (click)="openYourQRCode($event)"
                      data-cy="microsite-preview-hdr-qr-code">
                      <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="qr-code-outline"></ion-icon>
                    </ion-button>
                    <ion-button class="moreButton"
                      *ngIf="userData.webPublished === true && usernameLoading === false && userData.micrositeUserId !== ''"
                      size="small" fill="clear" (click)="presentMorePopover($event)"
                      data-cy="microsite-preview-hdr-moreBtn">
                      <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
                    </ion-button>
                  </div>
                </div>
                <!--
                  <ion-icon (click)="openMicrositeUsernameHelper()" color="primary" tappable
                  ios="information-circle-sharp" md="information-circle-sharp">
                </ion-icon>
                -->

              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </label>

      <div class="spacer-10"></div>

      <div id="preview-device">
        <iframe class="e2e-iframe-trusted-src" [src]="previewMicrositeLink" name="{{previewMicrositeLink}}"
          allow="fullscreen" data-cy="microsite-preview-frame-microsite"></iframe>
        <ion-spinner color="white" *ngIf="isLoading" name="crescent">
        </ion-spinner>
      </div>

      <div class="spacer-15"></div>


      <div id="updatesContainer" class="link" *ngIf="userData.webPublished === true">
        <div data-cy="microsite-preview-frame-notSeeingUpdates">Not seeing updates?</div>
        <div class="manualSync link" (click)="manualSync();" data-cy="microsite-preview-frame-manuallySync">
          <span class="bold">Manually sync changes</span>
          <img src="assets/imgs/sync.png">
        </div>
      </div>
    </div>

  </div>


</ion-content>